import React, { useState, useMemo, useEffect, useRef } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
  Cell,
} from "recharts";
import {
  deleteTemporaryFilters,
  setFiltersToOtherSheets,
  getL1SheetProperty,
  getL2SheetProperty,
  setWorkbookProperty,
  getWorkbookProperty,
  updateLevel2Properties,
  removeLevel2Properties,
  setLevel2Properties,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { useSelector, useDispatch } from "react-redux";
import { nanoid } from "@reduxjs/toolkit";
import { lineTransformData } from "../Utils/lineTransformData";
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import {
  getSheetControls,
  setSheetControls,
} from "../../../features/reduxworkbook/WorkbookControllingSlice";
import { formatNumber } from "../Utils/FormatNumbers";
import { sortData } from "../Utils/SortData";
import {
  dispatchSortValues,
  stackBarChartColorArray,
  stackedBarChartPosition,
  calculateYforXaxisLabel,
  calculateXforYaxisLabel,
} from "../Utils/ChartsFunctions";
import { CalculateAction, handleClicked } from "../../actions/Action";
import { CustomTooltip } from "../Custom/CustomTooltipContent";
import { handleHeirarchy } from "../Utils/HandleHeirarchy";
import { calculateAxis, rightAxisVisible } from "../Utils/calculateAxis";
import { useNavigate } from "react-router-dom";
import { CustomLegend } from "../Custom/CustomLegendContent";

//value
const renderCustomizedLabelValue = ({
  x,
  y,
  width,
  height,
  value,
  maxY,
  isTransposeVisible,
}) => {
  console.log(isTransposeVisible);
  const horizontalWidth = 200;
  const chartHeight = 300;
  const barSize = isTransposeVisible
    ? (value / maxY) * horizontalWidth
    : (value / maxY) * chartHeight;
  console.log(barSize);

  return (
    <g>
      <text
        x={x + width / 2}
        y={y - 10}
        fill="black"
        textAnchor="middle"
        fontSize={12}
      >
        {/* {Math.round(barSize)} px */}
      </text>
    </g>
  );
};

//for image
const boxImageAlignment = (imageAlignment) => {
  switch (imageAlignment.value) {
    case "contain":
      return "xMidYMid meet"; // Keeps full image visible
    case "cover":
      return "xMidYMid slice"; // Crops to fill box
    case "fill":
      return "none"; // Stretches fully
    default:
      return "xMidYMid meet"; // Default behavior
  }
};
const renderCustomizedLabel = ({
  x,
  y,
  width,
  height,
  value,
  imageWidth,
  imageHeight,
  imageAlignment,
  iconRotate,

  iconMapping,
  isTransposeVisible,
}) => {
  console.log(isTransposeVisible);

  console.log(imageWidth);
  console.log(imageHeight);

  const imageX = isTransposeVisible
    ? x + width + 5
    : x + width / 2 - imageWidth / 2;
  const imageY = isTransposeVisible
    ? y + height / 2 - imageHeight / 2
    : y - imageHeight - 5;

  const centerX = imageX + imageWidth / 2;
  const centerY = imageY + imageHeight / 2;

  const iconUrl = iconMapping[value] || "";

  // //for image

  return (
    <g>
      {iconUrl && (
        <image
          href={iconUrl}
          x={imageX}
          y={imageY}
          //rotation
          transform={`rotate(${iconRotate}, ${centerX}, ${centerY})`}
          width={imageWidth}
          height={imageHeight}
          preserveAspectRatio={boxImageAlignment(imageAlignment)}
        />
      )}
    </g>
  );
};

const parseMaxMin = (valueKey, maxMinObject) => {
  // console.log(valueKey, maxMinObject);
  if (!valueKey || !maxMinObject) {
    return { maxY: 100, minY: 0 };
    // return null
  }
  const { responseKey } = valueKey;
  const { min, max } = maxMinObject[responseKey];
  const minY = Math.min(min, 0);

  return { maxY: max, minY };
};
const StackedBarImageComp = ({
  Data,
  Sheetid,
  rowKeys: rawRowKeys,
  valueKeys = [],
  groupByKeys: rawGroupByKeys,
  toolTipKeys,
  sortProperties,
  isAnimataionOff,
  vizType,
  filters: filterArray,
  dataSourceID,
}) => {
  let timer;

  const reduxActiveBarIndex = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "activeBarIndex" })
  );
  const reduxStackActiveIndex = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "stackActiveIndex" })
  );
  const reduxClickedValues = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "clickedValues" })
  );
  const reduxActiveIndex = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "activeIndex" })
  );
  const [activeIndex, setActiveIndex] = useState(reduxActiveIndex || []);

  const rowKeys = rawRowKeys.map((item) => item.responseKey);
  console.log(rowKeys);

  const [activeBarIndex, setActiveBarIndex] = useState(
    reduxActiveBarIndex !== undefined ? reduxActiveBarIndex : []
  );
  // console.log(activeBarIndex);
  const isRightAxisVisible = rightAxisVisible({ valueKeys });
  const [stackActiveIndex, setStackActiveIndex] = useState(
    reduxStackActiveIndex !== undefined ? reduxStackActiveIndex : []
  );
  const [targetSheetid, setTargetSheetid] = useState(null);
  const [hoverIndex, setHoverIndex] = useState();
  // console.log(hoverIndex);
  const [stackHoverIndex, setStackHoverIndex] = useState();
  const [clickedValues, setClickedValues] = useState(
    reduxClickedValues !== undefined
      ? reduxClickedValues
      : {
          barClickedCaption: [],
          stackClickedCaption: [],
        }
  );

  const [clickTimeoutState, setClickTimeoutState] = useState(null);
  const [longestLabelWidth, setLongestLabelWidth] = useState(0);
  const SufixPrefix = { ...valueKeys.map((item) => item.numberFormat)[0] };
  const dispatch = useDispatch();
  const navigate = useNavigate(); // For URL navigation
  const groupByKeys = rawGroupByKeys.map((item) => item.responseKey);
  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const getOnClickProperties = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "onClick");
  });
  const getOnDoubleClickProperties = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "actions", "onDoubleClick")
  );
  const sheetsArray = useSelector((state) =>
    getWorkbookProperty(state, "sheets")
  );
  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || [];
  const workbookId =
    useSelector((state) => getWorkbookProperty(state, "_id")) || [];
  const workbookType =
    useSelector((state) => getWorkbookProperty(state, "type")) || [];
  const {
    colorSchemeid,
    barSize,
    isLabelVisible,
    labelPosition,
    labelFontSize,
    labelFontColor,
    labelRotate,
    isStackbarVisible,
    isTransposeVisible,
    isGridVisible,
    isLegendVisible,
    legendAlign,
    legendLayout,
    legendVerticalAlign,
    isAxeslabelVisible,
    imageWidth,
    imageHeight,
    isIconVisible,
    imageAlignment,
    iconType,
    iconStyle,
    iconRotate,
    isbarXasixIconVisible,
    colorMapping,
  } = customizationObject;
  console.log(colorMapping);

  // fontSize: labelFontSize,
  const [labelFontSizes, setlabelFontSizes] = useState(labelFontSize);
  console.log(labelFontSizes);

  // resize into dashboard
  const [iconSize, setIconSize] = useState({
    width: imageWidth,
    height: imageHeight,
  });

  const containerRef = useRef(null);
  useEffect(() => {
    const updateSizes = () => {
      if (!containerRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;
      const containerHeight = containerRef.current.offsetHeight;

      console.log("Container Width:", containerWidth);
      console.log("Container Height:", containerHeight);

      const maxSize = Math.min(containerWidth, containerHeight) / 2 - 10;

      const newWidth = Math.max(0, Math.min(imageWidth, maxSize * 0.4));
      const newHeight = Math.max(0, Math.min(imageHeight, maxSize * 0.4));

      console.log("Updated Width:", newWidth);
      console.log("Updated Height:", newHeight);

      setIconSize((prevSize) =>
        prevSize.width !== newWidth || prevSize.height !== newHeight
          ? { width: newWidth, height: newHeight }
          : prevSize
      );
      //fontSize
      setlabelFontSizes(
        Math.max(10, Math.min(labelFontSize, maxSize * 0.2)) // Ensure no negative or very small font sizes
      );
    };

    // Run on mount
    updateSizes();

    // Resize event listener
    window.addEventListener("resize", updateSizes);

    // Observe container changes dynamically
    const observer = new MutationObserver(updateSizes);
    if (containerRef.current) {
      observer.observe(containerRef.current, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    }

    return () => {
      window.removeEventListener("resize", updateSizes);
      observer.disconnect();
    };
  }, [containerRef, imageWidth, imageHeight, labelFontSize]);

  const iconMapping = customizationObject.iconMapping || {};
  const COLORS = getColourSchemeByID(colorSchemeid).colors;
  const {
    table: transformedData,
    lines: uniqueColumnValues,
    transformedTooltipKeys,
    maxMinObject,
  } = useMemo(() => {
    return lineTransformData(
      Data,
      rawRowKeys,
      rawGroupByKeys,
      valueKeys,
      toolTipKeys,
      true
    );
  }, [Data, rawGroupByKeys, rawRowKeys, valueKeys, toolTipKeys]);

  const { maxY, minY } = parseMaxMin(valueKeys[0], maxMinObject);

  const newArray =
    uniqueColumnValues.length > 0 && valueKeys.length > 0
      ? [
          ...uniqueColumnValues,
          ...valueKeys.map((obj) => `Total ${obj.responseKey}`),
        ]
      : [];

  if (rawGroupByKeys.length > 0) {
    dispatchSortValues({ newArray, dispatch, setSheetControls, Sheetid });
  }
  const sorteData = sortData({
    transformedData,
    sortProperties,
    rawRowKeys: rawRowKeys,
    rawGroupByKeys: rawGroupByKeys,
    requiredArray: rawGroupByKeys,
  });

  const xa = rawGroupByKeys[0];
  const yb = valueKeys[0];
  const ybiax = valueKeys[1];
  const yAxisResponseKey = xa?.rename;
  const xAxisCaption = yb?.caption;
  const ybiaXialCaption = ybiax?.caption;

  // find data, index
  let whatShouldDispatch;
  let groupResponseKey =
    rawGroupByKeys.length === 1 ? rawGroupByKeys[0].responseKey : undefined;
  const nanoId = nanoid();

  const handleClickEvent = ({
    hoverIndex,
    barIndex,
    barClickedValue,
    stackedIndex,
    stackClickedValue,
    event,
  }) => {
    console.log(barClickedValue);

    console.log(stackClickedValue);

    if (hoverIndex === null) {
      if (rawRowKeys.length === 0) {
        console.log("clickedOutside and stack is empty");
        whatShouldDispatch = "xAxisValue";
      } else {
        console.log("clickedOutside and stack is not empty");
        whatShouldDispatch = "xAxisValue";
      }
    } else {
      if (rawRowKeys.length === 0) {
        console.log("clickedInside and stack is empty");
        whatShouldDispatch = "xAxisValue";
      } else {
        console.log("clickedInside and stack is not empty");
        whatShouldDispatch = "xAxisValue&StackValue";
      }
    }
    console.log(whatShouldDispatch);
    if (!getOnClickProperties?.action && !getOnDoubleClickProperties?.action) {
      console.log("default filter applied");
      handleClicked({
        data: null,
        index: null,
        event: event,
        requiredArray: rawGroupByKeys,
        hoverIndex,
        dispatch,
        deleteTemporaryFilters,
        setFiltersToOtherSheets,
        Sheetid,
        clickedCaption: null,
        setClickedCaption: null,
        activeIndex: null,
        setActiveIndex: null,
        activeBarIndex,
        setActiveBarIndex,
        vizType,
        rawRowKeys,
        whatShouldDispatch,
        barIndex,
        stackedIndex,
        barClickedValue,
        stackClickedValue,
        stackActiveIndex,
        setStackActiveIndex,
        activeBarIndex,
        setActiveBarIndex,
        clickedValues,
        setClickedValues,
        setWorkbookProperty,
        filterArray,
        dataSourceID,
      });
    } else {
      if (
        (getOnClickProperties?.action === "Hierarchy" && rawGroupByKeys[0]) ||
        (getOnClickProperties?.action === "Hierarchy" &&
          rawRowKeys[0] &&
          rawGroupByKeys[0])
      ) {
        const rowCurrentValue =
          rawRowKeys[0] !== undefined && rawRowKeys[0]["rename"];
        const groupCurrentValue = rawGroupByKeys[0]["rename"];
        let groupFilterItemIs,
          rowFilterItemIs,
          isGroupHierarchyLastItemExist,
          isRowHierarchyLastItemExist,
          groupIsExpandable,
          rowIsExpandable;
        groupFilterItemIs = {
          columnName: rawGroupByKeys[0].columnName,
          dataType: rawGroupByKeys[0].dataType,
          uuid: rawGroupByKeys[0].uuid,
          rename: rawGroupByKeys[0].rename,
          sourceSheetId: Sheetid,
          nanoid: nanoId,
          selectedFilterValues: [barClickedValue],
          selectedOperator: "IN",
          filterType: "temporary",
          format: null,
          dataSourceID,
        };
        if (rawRowKeys[0]) {
          rowFilterItemIs = {
            columnName: rawRowKeys[0].columnName,
            dataType: rawRowKeys[0].dataType,
            uuid: rawRowKeys[0].uuid,
            rename: rawRowKeys[0].rename,
            sourceSheetId: Sheetid,
            nanoid: nanoId,
            selectedFilterValues: [stackClickedValue],
            selectedOperator: "IN",
            filterType: "temporary",
            format: null,
            dataSourceID,
          };
        }

        const rowHierarchy = rowCurrentValue
          ? hierarchy.find((item) =>
              item.hierarchyArray.find((arr) => arr.rename === rowCurrentValue)
            )
          : null;
        const groupHierarchy = groupCurrentValue
          ? hierarchy.find((item) =>
              item.hierarchyArray.find(
                (arr) => arr.rename === groupCurrentValue
              )
            )
          : null;
        rowIsExpandable =
          rowHierarchy !== undefined && rowHierarchy !== null ? true : false;
        groupIsExpandable =
          groupHierarchy !== undefined && groupHierarchy !== null
            ? true
            : false;
        isGroupHierarchyLastItemExist =
          groupHierarchy !== undefined &&
          groupHierarchy.hierarchyArray[
            groupHierarchy.hierarchyArray.length - 1
          ]["rename"] === groupCurrentValue;
        isRowHierarchyLastItemExist =
          rowHierarchy !== undefined &&
          rawRowKeys[0] &&
          rowHierarchy.hierarchyArray[rowHierarchy.hierarchyArray.length - 1][
            "rename"
          ] === rowCurrentValue;
        if (clickTimeoutState) {
          clearTimeout(clickTimeoutState);
          setClickTimeoutState(null);
          console.log("double clicked");
          handleHeirarchy({
            headerId: groupCurrentValue,
            foundHierachy: groupHierarchy,
            requiredArray: [],
            dispatch: dispatch,
            functionToAddAndUpdate: updateLevel2Properties,
            functionToRemove: removeLevel2Properties,
            Sheetid: Sheetid,
            vizType: vizType,
            functionWillBe: "replaceItemWithNextItem",
            groupHierarchy,
            rowHierarchy,
            rowCurrentValue,
            groupCurrentValue,
            rowIsExpandable,
            groupIsExpandable,
          });
          if (groupIsExpandable && !isGroupHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: groupFilterItemIs,
                itemInArray: true,
              })
            );
          }
          if (rowIsExpandable && !isRowHierarchyLastItemExist) {
            dispatch(
              setLevel2Properties({
                reduxKey: "filters",
                Sheetid,
                parentKey: "query",
                value: rowFilterItemIs,
                itemInArray: true,
              })
            );
          }
        } else {
          const timeout = setTimeout(() => {
            setClickTimeoutState(null);
            console.log("single clicked");
            handleHeirarchy({
              headerId: groupCurrentValue,
              foundHierachy: groupHierarchy,
              requiredArray: [],
              dispatch: dispatch,
              functionToAddAndUpdate: updateLevel2Properties,
              functionToRemove: removeLevel2Properties,
              Sheetid: Sheetid,
              vizType: vizType,
              functionWillBe: "replaceItemWithpreviousItem",
              groupHierarchy,
              rowHierarchy,
              rowCurrentValue,
              groupCurrentValue,
              rowIsExpandable,
              groupIsExpandable,
            });
            const findRemoveAbleItem = (
              hierarchyArray,
              currentIndex,
              filterArray
            ) => {
              console.log(currentIndex);
              const heirarchyPreivousItemIs =
                hierarchyArray[currentIndex - 1].uuid;
              console.log(heirarchyPreivousItemIs);
              const filterItemIs = filterArray.find(
                (filterItem) => filterItem.uuid === heirarchyPreivousItemIs
              );
              console.log(filterItemIs);
              if (filterItemIs) {
                return filterItemIs;
              }
              return undefined;
            };

            const groupCurrentIndex =
              groupHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === groupCurrentValue
              ) ?? -1;
            console.log(groupCurrentIndex);

            const rowCurrentIndex =
              rowHierarchy?.hierarchyArray.findIndex(
                (row) => row.rename === rowCurrentValue
              ) ?? -1;
            console.log(rowCurrentIndex);

            const groupRemoveAbleItemIs =
              groupCurrentIndex > 0
                ? findRemoveAbleItem(
                    groupHierarchy.hierarchyArray,
                    groupCurrentIndex,
                    filterArray
                  )
                : undefined;

            const rowRemoveAbleItemIs =
              rowCurrentIndex > 0
                ? findRemoveAbleItem(
                    rowHierarchy.hierarchyArray,
                    rowCurrentIndex,
                    filterArray
                  )
                : undefined;

            console.log(groupRemoveAbleItemIs);
            console.log(rowRemoveAbleItemIs);

            if (groupIsExpandable && groupRemoveAbleItemIs !== undefined) {
              dispatch(
                removeLevel2Properties({
                  reduxKey: "filters",
                  parentKey: "query",
                  value: groupRemoveAbleItemIs,
                  Sheetid,
                  itemInArray: true,
                })
              );
            }
            if (rowIsExpandable && rowRemoveAbleItemIs !== undefined) {
              console.log(rowRemoveAbleItemIs);

              // dispatch(
              //   removeLevel2Properties({
              //     reduxKey: "filters",
              //     parentKey: "query",
              //     value: rowRemoveAbleItemIs,
              //     Sheetid,
              //     itemInArray: true,
              //   })
              // );
            }
          }, 250);
          setClickTimeoutState(timeout);
        }
      } else {
        console.log(timer);
        if (timer) {
          //it is a second click
          clearTimeout(timer);
          timer = null;
          console.log("double");
          CalculateAction({
            data: null,
            index: null,
            event,
            requiredArray: rawGroupByKeys,
            hoverIndex,
            dispatch,
            deleteTemporaryFilters,
            setFiltersToOtherSheets,
            Sheetid,
            clickedCaption: null,
            setClickedCaption: null,
            activeIndex: null,
            setActiveIndex: null,
            activeBarIndex,
            setActiveBarIndex,
            vizType,
            rawRowKeys,
            whatShouldDispatch,
            barIndex,
            stackedIndex,
            barClickedValue,
            stackClickedValue,
            stackActiveIndex,
            setStackActiveIndex,
            activeBarIndex,
            setActiveBarIndex,
            clickedValues,
            setClickedValues,
            setWorkbookProperty,
            actionsProperty: getOnDoubleClickProperties,
            workbookId,
            workbookType,
            navigate,
            dataSourceID,
            sheetsArray,
          });
        } else {
          timer = setTimeout(() => {
            console.log("single");
            CalculateAction({
              data: null,
              index: null,
              event,
              requiredArray: rawGroupByKeys,
              hoverIndex,
              dispatch,
              deleteTemporaryFilters,
              setFiltersToOtherSheets,
              Sheetid,
              clickedCaption: null,
              setClickedCaption: null,
              activeIndex: null,
              setActiveIndex: null,
              activeBarIndex,
              setActiveBarIndex,
              vizType,
              rawRowKeys,
              whatShouldDispatch,
              barIndex,
              stackedIndex,
              barClickedValue,
              stackClickedValue,
              stackActiveIndex,
              setStackActiveIndex,
              activeBarIndex,
              setActiveBarIndex,
              clickedValues,
              setClickedValues,
              setWorkbookProperty,
              actionsProperty: getOnClickProperties,
              workbookId,
              workbookType,
              navigate,
              dataSourceID,
              sheetsArray,
            });
            timer = null;
          }, 300);
          console.log(timer);
        }
      }
    }
  };
  useEffect(() => {
    // console.log(Sheetid);
    dispatch(
      setSheetControls({
        Sheetid: Sheetid,
        controls: {
          activeBarIndex,
          stackActiveIndex,
          clickedValues,
        },
      })
    );
  }, [activeBarIndex, stackActiveIndex, clickedValues]);

  const tickFormatter = (tick) => {
    if (typeof tick === "number" || typeof tick === "string") {
      const formattedTick =
        typeof tick === "string" ? tick : formatNumber(tick, SufixPrefix);

      // Ensure formattedTick is a string
      const tickAsString = String(formattedTick);

      // Create a temporary canvas to measure the text width
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = "12px Arial"; // Use the same font as the chart

      // Handle multi-line ticks (e.g., "Key Growth")
      const lines = tickAsString.split(" "); // Split the tick into words
      console.log(lines);

      const lineWidths = lines.map((line) => context.measureText(line).width);
      console.log(lineWidths);

      const totalWidth = Math.max(...lineWidths); // Use the widest line

      // Adjust the longest label width based on context
      const adjustedMargin = SufixPrefix.mode === "Manual" ? 20 : 10;
      const marginOffset = isTransposeVisible ? 8 : adjustedMargin;

      setLongestLabelWidth(
        (prevWidth) => Math.max(prevWidth, totalWidth) - marginOffset
      );
      console.log(tickAsString);

      return tickAsString;
    }

    return tick;
  };

  const handleBarMouseEnter = (lineIndex, stackIndex) => {
    setHoverIndex(lineIndex);
    setStackHoverIndex(stackIndex);
  };

  const handleBarMouseLeave = () => {
    setHoverIndex(null);
  };

  const { left, top, bottom, right } = stackedBarChartPosition(
    isAxeslabelVisible,
    isTransposeVisible,
    SufixPrefix,
    imageHeight,
    imageWidth,
    isbarXasixIconVisible,
    longestLabelWidth,
    iconMapping
  );
  console.log(left, isAxeslabelVisible);

  //y axis here  horizontal with text wrap in this
  const CustomYAxisTick = (props) => {
    const {
      x,
      y,
      iconMapping,
      imageWidth,
      imageHeight,
      payload,
      maxWidth = 60,
    } = props;

    const values = payload?.value;
    const iconUrls = iconMapping[values] || "";

    const splitTextIntoLines = (text, maxWidth) => {
      if (!text) return [""];
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = "16px Arial"; // Ensure this matches the chart font

      const words = text?.split(" ");
      let lines = [];
      let currentLine = "";

      words.forEach((word) => {
        let testLine = currentLine ? `${currentLine} ${word}` : word;
        let textWidth = context.measureText(testLine).width;

        if (textWidth > maxWidth) {
          if (currentLine) lines.push(currentLine);
          currentLine = word;
        } else {
          currentLine = testLine;
        }
      });

      if (currentLine) lines.push(currentLine);
      return lines;
    };

    const lines = splitTextIntoLines(values, maxWidth);

    return (
      <g transform={`translate(${x},${y})`}>
        {iconUrls ? (
          <image
            href={iconUrls}
            width={imageWidth}
            height={imageHeight}
            x={-imageWidth}
            y={-imageHeight / 2}
            dy={10}
          />
        ) : (
          lines.map((line, index) => (
            <text
              key={index}
              x={-40} // Adjust positioning
              y={index * 14 - 4} // Adjust line spacing
              dy={10}
              textAnchor="middle"
              fontSize={16}
              fill="#666"
            >
              {line}
            </text>
          ))
        )}
      </g>
    );
  };

  //y axis default
  const DefaultYAxisTick = ({
    x,
    y,
    payload,
    tickFormatter,
    maxWidth = 60,
  }) => {
    const formattedValue = tickFormatter
      ? tickFormatter(payload.value)
      : payload.value;

    // Function to split text into multiple lines based on width
    const splitTextIntoLines = (text, maxWidth) => {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = "16px Arial"; // Ensure this matches the chart font

      const words = text.split(" ");
      let lines = [];
      let currentLine = "";

      words.forEach((word) => {
        let testLine = currentLine ? `${currentLine} ${word}` : word;
        let textWidth = context.measureText(testLine).width;

        if (textWidth > maxWidth) {
          if (currentLine) lines.push(currentLine);
          currentLine = word;
        } else {
          currentLine = testLine;
        }
      });

      if (currentLine) lines.push(currentLine);
      return lines;
    };

    const lines = splitTextIntoLines(formattedValue, maxWidth);

    return (
      <g transform={`translate(${x},${y})`}>
        {lines.map((line, index) => (
          <text
            key={index}
            x={0}
            y={index * 14} // Adjust line spacing
            dy={5}
            textAnchor="end"
            fontSize={16}
            fill="#666"
          >
            {line}
          </text>
        ))}
      </g>
    );
  };

  //x axistick icon
  const CustomXAxisTick = (props) => {
    console.log(props);
    const {
      x,
      y,
      width,
      height,
      iconMapping,
      imageWidth,
      imageHeight,
      value,
      inputData,
      dataKey,
      payload,
      isTransposeVisible,
    } = props;

    const values = payload?.value;
    const iconUrls = iconMapping[values] || "";
    console.log(imageHeight);

    return (
      <g transform={`translate(${x},${y})`}>
        {iconUrls ? (
          <image
            href={iconUrls}
            width={imageWidth}
            height={imageHeight}
            x={-imageWidth / 2} // Center icon horizontally
            y={10} // Adjust position to prevent overlap
          />
        ) : (
          <text
            x={0}
            y={0}
            dy={10}
            textAnchor="middle"
            fontSize={16}
            fill="#666"
          >
            {values}
          </text>
        )}
      </g>
    );
  };

  const DefaultXAxisTick = ({ x, y, payload, tickFormatter }) => {
    const formattedValue = tickFormatter
      ? tickFormatter(payload.value)
      : payload.value;

    return (
      <text x={x} y={y} dy={10} textAnchor="middle" fontSize={16} fill="#666">
        {formattedValue}
      </text>
    );
  };

  return (
    <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
      <ResponsiveContainer
        width="100%"
        height="100%"
        className="flex items-center justify-center"
      >
        <BarChart
          data={sorteData}
          layout={isTransposeVisible ? "vertical" : "horizontal"}
          margin={{
            left,

            bottom,

            top,
            right,
          }}
          onClick={(data, event) => {
            hoverIndex !== null
              ? console.log({
                  clickedValue: data.activeLabel,
                  index: data.activeTooltipIndex,
                })
              : handleClickEvent({
                  hoverIndex,
                  barClickedValue: data.activeLabel,
                  barIndex: data.activeTooltipIndex,
                  event,
                });
          }}
        >
          {isGridVisible && <CartesianGrid strokeDasharray="3 3" />}

          <XAxis
            type={isTransposeVisible ? "number" : "category"}
            dataKey={isTransposeVisible ? null : groupByKeys[0]}
            tickFormatter={tickFormatter}
            domain={[minY, maxY * 1.2]}
            tick={(props) =>
              isTransposeVisible ? (
                <DefaultXAxisTick {...props} tickFormatter={tickFormatter} />
              ) : isbarXasixIconVisible ? (
                CustomXAxisTick({
                  ...props,
                  iconMapping,

                  imageWidth: iconSize.width,
                  imageHeight: iconSize.height,

                  dataKey: groupByKeys[0],
                  inputData: sorteData,
                  isTransposeVisible,
                })
              ) : (
                <DefaultXAxisTick {...props} tickFormatter={tickFormatter} />
              )
            }
            label={
              isAxeslabelVisible
                ? {
                    content: ({ viewBox }) => {
                      const { x, y, width, height } = viewBox;
                      console.log(viewBox);
                      const centerX = x + width / 2;
                      console.log(centerX);

                      const centerY = calculateYforXaxisLabel({
                        isbarXasixIconVisible,
                        isTransposeVisible,
                        iconMapping,
                        imageHeight: iconSize.height,
                        imageWidth: iconSize.width,
                        x,
                        y,
                        width,
                        height,
                        isAxeslabelVisible,
                      });
                      console.log(centerY);

                      return (
                        <>
                          <text
                            x={centerX}
                            y={centerY}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fill={labelFontColor}
                            style={{
                              fontWeight: "normal",
                              fontSize: labelFontSizes,
                            }}
                            transform={
                              isTransposeVisible
                                ? null
                                : `rotate(0, ${centerX}, ${566})`
                            }
                          >
                            {isTransposeVisible
                              ? xAxisCaption
                              : yAxisResponseKey}
                          </text>
                        </>
                      );
                    },
                  }
                : null
            }
          />

          <YAxis
            yAxisId="left"
            type={isTransposeVisible ? "category" : "number"}
            dataKey={isTransposeVisible ? groupByKeys[0] : null}
            domain={[minY, maxY * 1.2]}
            tickFormatter={tickFormatter}
            // tickLine={false}
            allowDataOverflow
            //horizonatl  yasix

            tick={(props) =>
              isTransposeVisible ? (
                isbarXasixIconVisible ? (
                  CustomYAxisTick({
                    ...props,
                    iconMapping,
                    imageWidth: iconSize.width,
                    imageHeight: iconSize.height,

                    dataKey: groupByKeys[0],
                    inputData: sorteData,
                    isTransposeVisible,
                    maxWidth: 80,
                  })
                ) : (
                  <DefaultYAxisTick
                    {...props}
                    tickFormatter={tickFormatter}
                    maxWidth={80}
                  />
                )
              ) : (
                <DefaultYAxisTick
                  {...props}
                  tickFormatter={tickFormatter}
                  maxWidth={60}
                />
              )
            }
            label={
              isAxeslabelVisible
                ? {
                    content: ({ viewBox }) => {
                      const { x, y, height, width } = viewBox;
                      console.log(y);
                      console.log(viewBox);
                      const centerX = 15;

                      // const centerY = height / 2;

                      const centerY = y + height / 2;
                      console.log(centerY);

                      return (
                        <text
                          x={centerX}
                          y={centerY}
                          textAnchor="middle"
                          dominantBaseline={
                            isTransposeVisible ? "middle" : "hanging"
                          }
                          fill={labelFontColor}
                          style={{
                            fontWeight: "normal",
                            fontSize: labelFontSizes,
                          }}
                          transform={
                            isTransposeVisible
                              ? `rotate(-90, ${centerX},${centerY})`
                              : `rotate(-90, ${centerX},${centerY})`
                          }
                        >
                          {isTransposeVisible ? yAxisResponseKey : xAxisCaption}
                        </text>
                      );
                    },
                  }
                : null
            }
          />
          {/* right */}

          {isRightAxisVisible && !isTransposeVisible && (
            <YAxis
              yAxisId="right"
              orientation="right"
              type={isTransposeVisible ? "category" : "number"}
              dataKey={isTransposeVisible ? groupByKeys[0] : null}
              tickFormatter={tickFormatter}
              label={
                isAxeslabelVisible
                  ? {
                      content: ({ viewBox }) => {
                        const { x, y, height } = viewBox;

                        const adjustedX = isTransposeVisible ? x - 30 : x + 60;

                        const adjustedY = isTransposeVisible
                          ? 250
                          : y + height / 2; // Centered Y-axis label

                        return (
                          <text
                            x={adjustedX}
                            y={adjustedY}
                            textAnchor="middle"
                            dominantBaseline={
                              isTransposeVisible ? "middle" : "hanging"
                            }
                            fill={labelFontColor}
                            style={{
                              fontWeight: "normal",
                              fontSize: labelFontSize,
                            }}
                            transform={
                              isTransposeVisible
                                ? `rotate(-452, ${adjustedX}, 250)`
                                : `rotate(-90, ${adjustedX}, ${adjustedY})`
                            }
                          >
                            {isTransposeVisible
                              ? xAxisCaption
                              : ybiaXialCaption}
                          </text>
                        );
                      },
                    }
                  : null
              }
            />
          )}

                    <Tooltip
                        content={
                            <CustomTooltip
                                // tooltipKeys={toolTipKeys}
                                toolTipArray={toolTipKeys}
                                SufixPrefix={SufixPrefix}
                                colorSchemeid={colorSchemeid}
                                currentLineIndex={stackHoverIndex}
                                rowKeys={rawRowKeys}
                                headerKeys={uniqueColumnValues}
                                columnKeys={rawGroupByKeys}
                                valueKeys={valueKeys}
                                tooltipKeys={transformedTooltipKeys}
                                chartType={"bar"}
                                mainData={Data}
                                xAxisValue={groupByKeys[0]}
                                dimensionValue={rowKeys[0]}
                                metricVales={valueKeys.map((key) => key.responseKey)}
                                colorMapping={colorMapping}
                            />
                        }
                    />
                    {isLegendVisible && (
                        <Legend
                            iconType="square"
                            align={legendAlign.value}
                            verticalAlign={legendVerticalAlign.value}
                            layout={legendLayout.value}
                            content={
                                <CustomLegend
                                    {...{
                                        align: legendAlign.value,
                                        verticalAlign: legendVerticalAlign.value,
                                        layout: legendLayout.value,
                                        valueKeys,
                                    }}
                                />
                            }
                        />
                    )}
                    {uniqueColumnValues.map((item, stackIndex) => {
                        console.log(item);

            const calculateStackID = () => {
              const arrayOfString = item.split("|");
              return arrayOfString[arrayOfString.length - 1];
            };

            const measureValue = calculateStackID();
            console.log(measureValue);

            const calculatedStackId = isStackbarVisible ? measureValue : null;
            const dynamicAxisId = calculateAxis(measureValue, valueKeys);
            const { numberFormat } = valueKeys.find(
              (ValueObject) => ValueObject.responseKey === measureValue
            ) || { mode: "Auto" };

                        const baseColor =
                            colorMapping?.[item] || COLORS[stackIndex % COLORS.length];
                        console.log("Base Color:", baseColor);
                        console.log(baseColor);

                        console.log(colorMapping?.[item]);
                        return (
                            <Bar
                                key={stackIndex}
                                dataKey={item}
                                yAxisId={isTransposeVisible ? "left" : dynamicAxisId} // Use the dynamic axisId here
                                // fill={COLORS[stackIndex % COLORS.length]}
                                fill={baseColor}
                                barSize={barSize}
                                stackId={calculatedStackId}
                                // stroke={baseColor}
                                // strokeWidth={hoverIndex === stackIndex ? 3 : 2}


                onClick={(data, stackIndex, event) => {
                  hoverIndex !== null
                    ? handleClickEvent({
                        hoverIndex,
                        barClickedValue: data[`${groupResponseKey}`],
                        barIndex: hoverIndex,
                        stackedIndex: stackIndex,
                        stackClickedValue: uniqueColumnValues[stackIndex]
                          ? uniqueColumnValues[stackIndex].split("|")[0]
                          : undefined,
                        event,
                      })
                    : console.log({ data });
                }}
                onMouseEnter={(data, index) =>
                  handleBarMouseEnter(index, stackIndex)
                }
                onMouseLeave={handleBarMouseLeave}
                background={false}
                isAnimationActive={isAnimataionOff}
              >
                {/* LabelList */}
                {isLabelVisible && (
                  <LabelList
                    dataKey={item}
                    position={labelPosition.value}
                    fontSize={labelFontSize}
                    fill={labelFontColor}
                    stroke={labelFontColor}
                    offset={-55}
                    angle={labelRotate}
                    formatter={(value) => formatNumber(value, numberFormat)}
                  />
                )}
                {/* image compomnent */}

                {!isbarXasixIconVisible && (
                  <LabelList
                    dataKey={groupByKeys[0]}
                    position={labelPosition.value}
                    fontSize={labelFontSize}
                    fill={labelFontColor}
                    stroke={labelFontColor}
                    offset={-55}
                    angle={labelRotate}
                    formatter={(value) => formatNumber(value, numberFormat)}
                    content={(props) =>
                      renderCustomizedLabel({
                        ...props,
                        // imageWidth,
                        // imageHeight,
                        imageWidth: iconSize.width,
                        imageHeight: iconSize.height,
                        imageAlignment: imageAlignment || "contain",
                        dataKey: groupByKeys[0],
                        inputData: sorteData,
                        iconMapping,
                        iconRotate,
                        isTransposeVisible,
                      })
                    }
                  />
                )}
                {/* {sorteData.map((e, i) => (
                                    <Cell key={`cell-${i}`} fill={baseColor} /> // Static color for all bars
                                ))} */}
                {sorteData.map((e, i) => {
                  console.log(i);

                  const { barClickedCaption, stackClickedCaption } =
                    clickedValues;
                  return (
                    <Cell
                      key={`cell-${i}`}
                      fill={stackBarChartColorArray({
                        activeBarIndex,
                        stackActiveIndex,
                        stackIndex,
                        barClickedCaption,
                        rawGroupByKeys,
                        COLORS,
                        vizType,
                        baseColor,
                        e,
                      })}
                    />
                  );
                })}
              </Bar>
            );
          })}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StackedBarImageComp;
